import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import {
  VALIDATE_MBS_STATE,
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  ADD_EVENT_TO_BETSLIP_FAILURE,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP,
  REMOVE_EVENT_FROM_BETSLIP,
  SET_BETSLIP_MULTIPLIER,
  SET_BETSLIP_COUPON_COUNT,
  SET_BETSLIP_SYSTEM,
  VALIDATE_BETSLIP_REQUEST,
  VALIDATE_BETSLIP_SUCCESS,
  VALIDATE_BETSLIP_FAILURE,
  TOGGLE_BETSLIP_BANKER,
  SET_BETSLIP_FROM_LOCAL_STORAGE,
  RESET_BETSLIP,
  BETSLIP_EVENT_VERSION_WS_UPDATE,
  BETSLIP_EVENT_ODD_WS_UPDATE,
  BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE,
  ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET,
  BETSLIP_SET_HAS_LIVE_EVENT,
  BETSLIP_OPENED,
  BETSLIP_CLOSED,
  PREDICTA_COMPUTE_REQUEST,
  PREDICTA_COMPUTE_SUCCESS,
  PREDICTA_COMPUTE_FAILURE,
  SET_PREDICTA_SUGGESTION_ACCEPTED
} from 'Store/constants';
import {
  BETTING_STATUS
} from 'Store/constants/sportTypes';
import inputMinMaxValidator from 'Utils/inputMinMaxValidator';
import { MULTIPLIER_MIN_VALUE, MULTIPLIER_MAX_VALUE } from 'Store/constants';
import { calculateOddValue } from 'Utils/calculateOddValue';
import getDefaultStakeAmount from 'Utils/getDefaultStakeAmount';

export const initialStateBetSlip = {
  validateData: {
    data: {
      availableSystems: [],
      canPlaySuperSystem: false,
      columnCount: 0,
      couponCount: 1,
      couponCost: 0,
      expectedWinAmount: 0,
      isValid: false,
      multiplier: 0,
      selectedSystems: [0],
      status: {
        code: 0,
        message: ''
      },
      totalOdd: 0.00
    },
    isLoading: false,
    error: null
  },
  predictaSuggestionAccepted: false,
  couponDetails: [],
  coupon: {
    availableSystems: [],
    channel: 1, // MOBILE_WEB
    totalOdd: 1.00,
    couponCount: 1,
    multiplier: getDefaultStakeAmount(),
    couponCost: getDefaultStakeAmount(),
    multiCouponCount: 1,
    canPlayMultipleCoupons: true,
    expectedWinAmount: 0,
    system: [1],
    source: null,
    sourceCouponId: null,
    bets: [],
  },
  atrium: {
    betCount: 0,
    odd: 0.00
  },
  isSystemSelected: false,
  isLoading: null,
  error: null,
  isMBSValid: false,
  isMBSCombinationValid: true,
  hasLiveEvent: false,
  isLoadedFromLS: false,
  isOpen: false,
  isSettingsOpen: false,
  lastRemovedBet: null,
  undoStatus: null
};

function compareObjectKeys (couponDetails, wsUpdate) {
  let newObject = {};
  couponDetails.bets.forEach(bet => {

    if (bet.id === wsUpdate.id) {
      newObject = {
        ...couponDetails,
        bets: [{
          ...couponDetails.bets[0],
          banker: wsUpdate.banker,
          odd: wsUpdate.odds,
          prevOdd: wsUpdate.prevOdd,
          topWinOdds: wsUpdate?.topWinOdds
        }],
        mbs: wsUpdate.mbs,
        isLive: wsUpdate.isLive,
      };
    }
  });
  return newObject;
}

const setBettingStatus = status => {

  if (BETTING_STATUS.OPEN.includes(status)) {
    return null;
  }

  if (BETTING_STATUS.SUSPENDED.includes(status)) {
    return 'Bahis beklemeye alınmıştır.';
  }

  if (BETTING_STATUS.CLOSE.includes(status)) {
    return 'Bahse kapanmıştır.';
  }

};

export default (state = initialStateBetSlip, action) => {
  switch (action.type) {
    case SET_BETSLIP_FROM_LOCAL_STORAGE: {
      const betSlip = action.payload.betSlip || initialStateBetSlip;
      return {
        ...betSlip,
        isLoadedFromLS: true
      };
    }

    case BETSLIP_SET_HAS_LIVE_EVENT:
      return {
        ...state,
        hasLiveEvent: action.payload
      };

    case BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE: {
      const { eventId, wsBettingStatus } = action.payload;

      return {
        ...state,
        couponDetails: state.couponDetails.map(item => item.eventId === eventId ? {
          ...item,
          wsBettingStatus: setBettingStatus(wsBettingStatus)
        } : item)
      };
    }

    case BETSLIP_EVENT_ODD_WS_UPDATE: {
      const { payload } = action;

      const betPayload = cloneDeep(payload);
      delete betPayload.prevOdd;

      const newBets = state.coupon.bets.map(betItem => betItem.eventId === betPayload.eventId ? {
        ...betItem,
        ...betPayload
      } : betItem);

      const atriumOdd = calculateOddValue(newBets);

      return {
        ...state,
        coupon: {
          ...state.coupon,
          bets: newBets,
        },
        couponDetails: state.couponDetails.map(couponDetail => couponDetail.eventId === payload.eventId ? compareObjectKeys(couponDetail, payload) : couponDetail),
        atrium: {
          betCount: newBets.length,
          odd: atriumOdd
        }
      };
    }

    case BETSLIP_EVENT_VERSION_WS_UPDATE: {
      const { eventId, eventVersion } = action.payload;

      return {
        ...state,
        coupon: {
          ...state.coupon,
          bets: state.coupon.bets.map(betItem => betItem.eventId === eventId ? ({
            ...betItem,
            eventVersion
          }) : betItem)
        }
      };
    }

    case VALIDATE_MBS_STATE: {
      const { coupon, couponDetails } = state;

      // Filter suspended or closed events.
      const filteredEvents = couponDetails.filter(bet => !bet.wsBettingStatus);

      const maxMbsCount = Math.max(...filteredEvents.map(couponDetail => couponDetail.bets[0].mbs));

      const isMBSValid = filteredEvents.length > 0 && maxMbsCount && maxMbsCount <= filteredEvents.length;
      const calculatedOdd = calculateOddValue(coupon.bets);

      if (isMBSValid) {
        return {
          ...state,
          coupon: {
            ...coupon,
            totalOdd: calculatedOdd,
            expectedWinAmount: calculatedOdd * coupon.multiplier,
          },
          isMBSValid
        };
      } else {

        return {
          ...state,
          validateData: {
            ...state.validateData,
            data: {
              ...state.validateData.data,
              availableSystems: [],
            }
          },
          coupon: {
            ...coupon,
            totalOdd: calculatedOdd,
            expectedWinAmount: calculatedOdd * coupon.multiplier,
            system: [coupon.bets.length]
          },
          isMBSValid,
          isSystemSelected: false
        };
      }
    }

    case ADD_EVENT_TO_BETSLIP_SUCCESS: {
      const { event, eventDetails, source, writerName, probabilityLevel } = action.payload;
      const { couponDetails, coupon, isSystemSelected } = state;

      let newCouponDetails, newCouponEvents;

      if (!couponDetails.length) {
        if (writerName) {
          eventDetails.writerName = writerName;
        }
        if (probabilityLevel) {
          eventDetails.probabilityLevel = probabilityLevel;
        }
        newCouponDetails = [eventDetails];
        newCouponEvents = [event];
      } else {
        const isEventInCoupon = couponDetails.some(couponDetailsEvent => couponDetailsEvent.eventId === eventDetails.eventId);

        if (isEventInCoupon) {
          newCouponDetails = couponDetails.map(couponDetailsEvent => {
            if (couponDetailsEvent.eventId === eventDetails.eventId) {
              if (writerName) {
                couponDetailsEvent.writerName = writerName;
              } else if ( couponDetailsEvent.bets[0].marketId !== eventDetails.bets[0].marketId ) {
                delete couponDetailsEvent.writerName;
              }

              if (probabilityLevel) {
                couponDetailsEvent.probabilityLevel = probabilityLevel;
              } else if (couponDetailsEvent.bets[0].marketId !== eventDetails.bets[0].marketId) {
                delete couponDetailsEvent.probabilityLevel;
              }

              return {
                ...couponDetailsEvent,
                bets: [eventDetails.bets[0]]
              };
            }
            return couponDetailsEvent;
          });

          newCouponEvents = coupon.bets.map(couponEvent => couponEvent.eventId === event.eventId ? event : couponEvent);
        } else {
          if (writerName) {
            eventDetails.writerName = writerName;
          }
          if (probabilityLevel) {
            eventDetails.probabilityLevel = probabilityLevel;
          }
          newCouponDetails = [...couponDetails, eventDetails];
          newCouponEvents = [...coupon.bets, event];
        }
      }

      const newAtriumOdd = calculateOddValue(newCouponEvents);
      const newSelectedSystems = isSystemSelected ? state.coupon.system : [newCouponEvents.length];
      const isFreshCoupon = !couponDetails.length;

      const multiplierObject = inputMinMaxValidator({
        id: 'multiplier',
        value: isFreshCoupon ? getDefaultStakeAmount() : state.coupon.multiplier,
        options: {
          min: MULTIPLIER_MIN_VALUE,
          max: MULTIPLIER_MAX_VALUE,
        },
        system: newSelectedSystems,
        betCount: newCouponEvents.length
      });

      return {
        ...state,
        coupon: {
          ...state.coupon,
          bets: newCouponEvents,
          system: newSelectedSystems,
          multiplier: multiplierObject.value,
          source: source
        },
        couponDetails: newCouponDetails,
        atrium: {
          betCount: newCouponEvents.length,
          odd: newAtriumOdd
        },
        lastRemovedBet: null
      };
    }

    case ADD_EVENT_TO_BETSLIP_FAILURE: {
      return { ...state, toastMessage: action.toastMessage };
    }

    case ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET: {
      return { ...state, toastMessage: null };
    }

    case ADD_MULTIPLE_EVENTS_TO_BETSLIP: {
      const { events, details, source, sourceCouponId, forceSystem } = action.payload;

      const newAtriumOdd = calculateOddValue(events);

      let newState = {
        ...state,
        coupon: {
          ...state.coupon,
          bets: [...events],
          system: forceSystem ?? [events.length]
        },
        couponDetails: [...details],
        atrium: {
          betCount: events.length,
          odd: newAtriumOdd
        },
        lastRemovedBet: null
      };

      if (source || sourceCouponId) {
        newState = { ...newState, coupon: { ...newState.coupon, source, sourceCouponId } };
      }

      return newState;
    }

    case REMOVE_EVENT_FROM_BETSLIP: {
      const { oddId, skipSetLastRemovedBet } = action.payload;
      const filteredCouponDetails = filter(state.couponDetails, event => event.bets[0].id !== oddId);
      const filteredCouponBets = filter(state.coupon.bets, bet => bet.id !== oddId);
      const newAtriumOdd = calculateOddValue(filteredCouponBets);

      const newSelectedSystems = state.isSystemSelected ? state.coupon.system : [filteredCouponBets.length];

      const removedCouponDetail = state.couponDetails.find(cd =>
        cd.bets.some(bet => bet.id === oddId)
      );

      const multiplierObject = inputMinMaxValidator({
        id: 'multiplier',
        value: state.coupon.multiplier,
        options: {
          min: MULTIPLIER_MIN_VALUE,
          max: MULTIPLIER_MAX_VALUE,
        },
        system: newSelectedSystems,
        betCount: filteredCouponBets.length
      });

      let newState = {
        ...state,
        coupon: {
          ...state.coupon,
          bets: filteredCouponBets,
          system: newSelectedSystems,
          multiplier: multiplierObject.value
        },
        couponDetails: filteredCouponDetails,
        atrium: {
          betCount: filteredCouponBets.length,
          odd: newAtriumOdd
        },
        // eslint-disable-next-line no-nested-ternary
        lastRemovedBet: skipSetLastRemovedBet ? state.lastRemovedBet : (filteredCouponDetails.length > 0 ? null : removedCouponDetail || null),
      };

      if (isEmpty(filteredCouponBets)) {
        newState.validateData = {
          ...initialStateBetSlip.validateData
        };
      }

      return newState;
    }

    case 'UNDO_LAST_REMOVED_BET': {
      const newBets = [...state.coupon.bets, ...state.lastRemovedBet.bets];
      const newCouponDetails = [...state.couponDetails, state.lastRemovedBet];

      return {
        ...state,
        coupon: {
          ...state.coupon,
          bets: newBets,
        },
        couponDetails: newCouponDetails,
        lastRemovedBet: newBets.length === 0 ? null : state.lastRemovedBet,
      };
    }

    case 'SET_LAST_REMOVED_BET': {
      return {
        ...state,
        lastRemovedBet: action.payload
      };
    }


    case TOGGLE_BETSLIP_BANKER: {
      const { eventId, marketId, marketOutcomeNo } = action.payload;

      const newCouponEvents = state.coupon.bets.map(couponEvent =>
        couponEvent.eventId === eventId && couponEvent.marketId === marketId && couponEvent.marketOutcomeNo === marketOutcomeNo
          ? {
            ...couponEvent,
            banker: !couponEvent.banker
          }
          : couponEvent
      );

      const newCouponDetails = state.couponDetails.map(couponDetailsEvent => {
        if (couponDetailsEvent.eventId === eventId) {
          let newBets = couponDetailsEvent.bets.map(bet =>
            bet.marketId === marketId && bet.marketOutcomeNo === marketOutcomeNo
              ? {
                ...bet,
                banker: !bet.banker
              }
              : bet
          );

          return {
            ...couponDetailsEvent,
            bets: newBets
          };
        } else {
          return couponDetailsEvent;
        }
      });
      const bankerCount = newCouponDetails?.flatMap(obj => obj?.bets).filter(b => b?.banker)?.length;
      return {
        ...state,
        coupon: {
          ...state.coupon,
          bets: newCouponEvents,
          ...(newCouponDetails?.length === bankerCount && { multiplier: getDefaultStakeAmount() })
        },
        couponDetails: newCouponDetails
      };
    }

    case SET_BETSLIP_MULTIPLIER: {
      const { isMBSValid, coupon } = state;

      let newState = {
        ...state,
        coupon: {
          ...coupon,
          multiplier: action.payload
        }
      };
      if (!isMBSValid) {
        newState.coupon = calculateCouponManually(newState.coupon);
      }

      return newState;
    }

    case SET_BETSLIP_COUPON_COUNT: {
      const { isMBSValid, coupon } = state;

      let newState = {
        ...state,
        coupon: {
          ...coupon,
          couponCount: action.payload
        }
      };
      if (!isMBSValid) {
        newState.coupon = calculateCouponManually(newState.coupon);
      }

      return newState;
    }

    case SET_BETSLIP_SYSTEM: {
      let systemValue;
      let multiplier;
      let isSystemSelected = true;
      if (action.payload.length > 0 && action.payload[0] !== 0) {
        systemValue = action.payload;
        if ( state?.addedRebetButton === 'Kupona Ekle') {
          systemValue = [state.coupon.bets.length];
          isSystemSelected = false;
          state.addedRebetButton = null;
        } else
        if ( state?.addedRebetButton === 'Tekrar Oyna') {
          isSystemSelected = false;
          state.addedRebetButton = null;
        } else {
          if ((state.coupon.bets.length === action.payload[0] && action.payload.length === 1))
            isSystemSelected = false;
        }
      } else {
        systemValue = [state.coupon.bets.length];
        isSystemSelected = false;
      }

      const currentBetsCount = state.coupon.bets?.length;
      const wasSystemCoupon = !(state.coupon.system?.length === 1 && state.coupon.system.includes(currentBetsCount));
      const isLeavingSystem = !isSystemSelected && wasSystemCoupon;

      const multiplierObject = inputMinMaxValidator({
        id: 'multiplier',
        value: isLeavingSystem ? getDefaultStakeAmount() : state.coupon.multiplier,
        options: {
          min: MULTIPLIER_MIN_VALUE,
          max: MULTIPLIER_MAX_VALUE,
        },
        system: action.payload,
        betCount: state.coupon.bets.length
      });

      multiplier = isSystemSelected && !state.isSystemSelected ? 1 : multiplierObject.value;

      const bankerCount = state?.coupon.bets?.filter(b => b?.banker)?.length;
      const betsCount = state?.coupon.bets?.length;

      if (bankerCount === betsCount || action.payload.length === 0) {
        multiplier = getDefaultStakeAmount();
      }

      return {
        ...state,
        coupon: {
          ...state.coupon,
          system: systemValue,
          multiplier: multiplier
        },
        isSystemSelected: isSystemSelected
      };
    }

    case VALIDATE_BETSLIP_REQUEST:
      return {
        ...state,
        validateData: {
          ...state.validateData,
          isLoading: !action.wsUpdated,
          error: null
        }
      };

    case VALIDATE_BETSLIP_SUCCESS: {
      const availableSystemsArray = typeof action.payload.availableSystems === 'number' ? [action.payload.availableSystems] : action.payload.availableSystems;

      let newSelectedSystems = [];
      action.payload.selectedSystems.forEach(selectedSystem => {
        if (availableSystemsArray.includes(selectedSystem)) {
          newSelectedSystems.push(selectedSystem);
        }
      });

      if (newSelectedSystems.length === 0) {
        newSelectedSystems = [state.coupon.bets.length];
      }

      return {
        ...state,
        validateData: {
          data: action.payload,
          isLoading: false,
          error: null
        },
        coupon: {
          ...state.coupon,
          system: newSelectedSystems,
          couponCost: action.payload.couponCost,
          totalOdd: action.payload.totalOdd,
          multiplier: action.payload.multiplier,
          expectedWinAmount: action.payload.expectedWinAmount,
          availableSystems: availableSystemsArray,
          ...(action.payload.multiCouponCount ? { couponCount: action.payload.multiCouponCount } : {} ),
          canPlayMultipleCoupons: action.payload.canPlayMultipleCoupons,
          multiCouponCount: action.payload.multiCouponCount
        },
        atrium: {
          ...state.atrium,
          odd: action.payload.totalOdd
        },
        isSystemSelected: false,
        isMBSCombinationValid: true
      };
    }

    case VALIDATE_BETSLIP_FAILURE: {

      const { payload } = action;

      if (payload?.code === 1029) {
        return {
          ...state,
          validateData: {
            data: {
              ...state.validateData.data,
              availableSystems: payload.extras?.availableSystems,
              columnCount: payload.extras?.columnCount
            },
            isLoading: false,
            error: payload.extras
          },
          isMBSCombinationValid: true
        };
      }

      return {
        ...state,
        validateData: {
          data: {
            ...initialStateBetSlip.validateData.data,
          },
          isLoading: false,
          error: payload
        },
        isMBSCombinationValid: payload?.code !== 1021
      };
    }

    case PREDICTA_COMPUTE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case PREDICTA_COMPUTE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        validateData: {
          ...state.validateData,
          data: {
            ...state.validateData.data,
            calculatedProbability: action.payload.calculatedProbability
          }
        }
      };

    case PREDICTA_COMPUTE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case RESET_BETSLIP:
      return {
        ...initialStateBetSlip,
        coupon: {
          ...initialStateBetSlip.coupon,
          multiplier: getDefaultStakeAmount(),
          couponCost: getDefaultStakeAmount(),
        }
      };

    case BETSLIP_OPENED:
      return {
        ...state,
        isOpen: true,
      };

    case BETSLIP_CLOSED:
      return {
        ...state,
        isOpen: false,
      };

    case 'UNDO_BET_STATUS':
      return {
        ...state,
        undoStatus: action.payload
      };

    case SET_PREDICTA_SUGGESTION_ACCEPTED:
      return {
        ...state,
        predictaSuggestionAccepted: action.payload
      };

    default:
      return state;
  }
};


const calculateCouponManually = coupon => {
  return {
    ...coupon,
    couponCost: coupon.multiplier,
    expectedWinAmount: coupon.multiplier * coupon.totalOdd
  };
};
